export enum EtapasEnsino {
    CRECHE = 1,
    CRECHE_MENOR_1_ANO = 10,
    CRECHE_1_ANO = 11,
    CRECHE_2_ANOS = 12,
    CRECHE_3_ANOS = 13,
    PRE_ESCOLA = 2,
    FUNDAMENTAL_INICIAIS = 3,
    FUNDAMENTAL_FINAIS = 4,
    MEDIO = 5,
    EJA = 6
}
